export default __webpack_public_path__ + "static/media/NoWishlist.c436841f.svg";